import RecoverStep from "./recover_step";
import {attachSelectableHandler} from "../utils/recover_utils";
import {REPLIBIT_RECOVER_TYPE, BRC_RECOVER_TYPE} from "../utils/recover_consts";

const TEMPLATE = 'tool-select';

const recoveryTypeMap = {
  'brc': BRC_RECOVER_TYPE,
  'x360recover': REPLIBIT_RECOVER_TYPE,
};

export default class RecoverToolSelectStep extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    data.tmp = { previousStep: fr.currentStep };
    data.showBackButton = (data.flowName === 'GeneralResellerRecoverFlow' && !data.resellerHasOneClient);
  }

  postRender(data, el, fr) {
    data.showBackButton = true;
    attachSelectableHandler(el, (d) => {
      data.type = recoveryTypeMap[d.type];
      this.setRecoveryFeaturesByRecoverType(data);
    });
  }

  setRecoveryFeaturesByRecoverType(data) {
    if (data.type === REPLIBIT_RECOVER_TYPE) {
      data.disabledFFR = true;
      data.disabledBMR = true;
    } else {
      data.disabledFFR = false;
      data.disabledBMR = false;
    }
  }
}
